// extracted by mini-css-extract-plugin
export var socialIconAction = "socialIconLink-module--socialIconAction--S4o6l";
export var wechatQrBackdrop = "socialIconLink-module--wechatQrBackdrop--YUUgQ";
export var wechatQrClose = "socialIconLink-module--wechatQrClose--i9E25";
export var wechatQrImage = "socialIconLink-module--wechatQrImage--xSjjI";
export var wechatQrOverlay = "socialIconLink-module--wechatQrOverlay--uRa-D";
export var wechatQrPanel = "socialIconLink-module--wechatQrPanel--Wl6nr";
export var wechatQrTitle = "socialIconLink-module--wechatQrTitle--JYdSb";